import axios from 'axios';
import { BASE_BACKEND_URL } from '../constants/base';
import { getIdFromLocalStorage } from './base';
import { notificationStore } from '../store/Notification';
import authStore from '../store/Auth';
import DataStore from '../store';

const axiosRequest = axios.create({
  baseURL: BASE_BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Credentials': true,
    'X-Client-ID': getIdFromLocalStorage(),
    'X-User-Name': authStore.getUserName(),
  },
});

axiosRequest.interceptors.request.use((config) => {
  config.headers['X-Client-ID'] = getIdFromLocalStorage();
  config.headers['X-User-Name'] = authStore.getUserName() || '';
  return config;
});

export const apiRequest = async (
  url: string,
  method: string,
  data?: any,
  extraSettings: any = {}
) => {
  try {
    const response = await axiosRequest({
      url,
      method: method.toUpperCase(),
      ...(method === 'GET' ? {} : { data }),
      ...extraSettings,
    });
    const contentType = String(response.headers['content-type'] || '');

    if (contentType.indexOf('application/zip') !== -1) {
      const contentDisposition = String(
        response.headers['content-disposition'] || ''
      );
      let filename = `download-${new Date().toISOString()}.zip`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      return {
        blob: response.data,
        filename,
        messageType: response.data.messageType,
      };
    }

    let responseData = response?.data;

    if (
      extraSettings.responseType === 'blob' &&
      contentType === 'application/json'
    ) {
      const text = await responseData?.text();
      responseData = JSON.parse(text);
    }
    if (responseData?.message && responseData?.messageType !== 'confirm') {
      notificationStore.showMessage(
        responseData?.message,
        responseData?.messageType || 'info'
      );
    }

    return responseData;
  } catch (error) {
    console.error('API Error:', error);
    notificationStore.showMessage('Backend site is out of service', 'error');
    throw error;
  }
};

export const checkDownloadStatusAndDownload = async (jobId: string) => {
  const timeout = 180_000;
  const interval = 3000;
  const start = Date.now();
  DataStore.setProcessing(true);
  const re = async (): Promise<boolean> => {
    while (Date.now() - start < timeout) {
      const res = await DataStore.getStatusJobForDownload(jobId);
      if (res && res.status === 'ready') {
        DataStore.setProcessing(false);
        return true;
      }
      await new Promise((r) => setTimeout(r, interval));
    }
    DataStore.setProcessing(false);
    throw new Error('Download preparation timed out.');
  };

  return re();
};
